import { useEffect, useState } from "react";

import { changeTheme } from "../components/TopNavbar";
import store from "../redux/store";
import { getCookie, setCookie } from "../services";
import { COOKIES_THEME, THEMES } from "../utils/constants";

export const useTheme = () => {
  const cookieTheme = getCookie(COOKIES_THEME);
  const [theme, setTheme] = useState(cookieTheme ? cookieTheme : THEMES.light);

  useEffect(() => {
    store.dispatch(changeTheme({ theme: theme }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Batch DOM operations for better performance
    requestAnimationFrame(() => {
      document.documentElement.dataset.theme = theme;
    });
  }, [theme]);

  const onToggleTheme = () => {
    const t = theme === THEMES.dark ? THEMES.light : THEMES.dark;
    setCookie(COOKIES_THEME, t);
    setTheme(t);
    store.dispatch(changeTheme({ theme: t }));
  };

  const isDarkTheme = theme === THEMES.dark;

  return { onToggleTheme, isDarkTheme };
};
